import React, { useEffect, useState } from 'react';
import LogoMark from '../assets/images/Eulua_Logo-320.webp';
import { useLanguage } from '../contexts/LanguageContext';
import './LoadingScreen.css';

const DEFAULT_MESSAGES = [
  'Connecting you with verified suppliers',
  'Preparing products and commercial terms',
  'Building your Eulua experience',
];

const LoadingScreen = ({
  eyebrow = 'GLOBAL B2B MARKETPLACE',
  title = 'Preparing your experience',
  messages = DEFAULT_MESSAGES,
}) => {
  const { t } = useLanguage();
  const [messageIndex, setMessageIndex] = useState(0);
  const translatedTitle = t(title);
  const translatedMessage = t(messages[messageIndex]);

  useEffect(() => {
    if (messages.length < 2) return undefined;

    const interval = window.setInterval(() => {
      setMessageIndex((current) => (current + 1) % messages.length);
    }, 1800);

    return () => window.clearInterval(interval);
  }, [messages]);

  const handlePointerMove = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty('--pointer-x', `${event.clientX - bounds.left}px`);
    event.currentTarget.style.setProperty('--pointer-y', `${event.clientY - bounds.top}px`);
  };

  const resetPointerGlow = (event) => {
    event.currentTarget.style.removeProperty('--pointer-x');
    event.currentTarget.style.removeProperty('--pointer-y');
  };

  return (
    <div
      className="eulua-loader"
      role="status"
      aria-live="polite"
      aria-label={`${translatedTitle}. ${translatedMessage}`}
      onPointerMove={handlePointerMove}
      onPointerLeave={resetPointerGlow}
    >
      <div className="eulua-loader__aurora eulua-loader__aurora--one" aria-hidden="true" />
      <div className="eulua-loader__aurora eulua-loader__aurora--two" aria-hidden="true" />

      <section className="eulua-loader__panel">
        <div className="eulua-loader__brand" aria-hidden="true">
          <span className="eulua-loader__logo-wrap">
            <img src={LogoMark} alt="" className="eulua-loader__logo" />
          </span>
          <span className="eulua-loader__wordmark">EULUA</span>
        </div>

        <div className="eulua-loader__network" aria-hidden="true">
          <span className="eulua-loader__orbit eulua-loader__orbit--outer" />
          <span className="eulua-loader__orbit eulua-loader__orbit--inner" />
          <span className="eulua-loader__route eulua-loader__route--one" />
          <span className="eulua-loader__route eulua-loader__route--two" />
          <span className="eulua-loader__node eulua-loader__node--one" />
          <span className="eulua-loader__node eulua-loader__node--two" />
          <span className="eulua-loader__node eulua-loader__node--three" />
          <span className="eulua-loader__hub">
            <img src={LogoMark} alt="" />
          </span>
        </div>

        <div className="eulua-loader__copy">
          <span className="eulua-loader__eyebrow">{t(eyebrow)}</span>
          <h1>{translatedTitle}</h1>
          <p key={messageIndex}>{translatedMessage}</p>
        </div>

        <div className="eulua-loader__progress" aria-hidden="true">
          <span />
        </div>

        <div className="eulua-loader__meta" aria-hidden="true">
          <span>{t('Verified suppliers')}</span>
          <i />
          <span>{t('Secure commerce')}</span>
          <i />
          <span>{t('Global reach')}</span>
        </div>
      </section>
    </div>
  );
};

export default LoadingScreen;
